import FaimLocale from "faim/dist/locale/zh-cn.mjs";
import upload from '../upload'

export default {
  ...FaimLocale.FaUpload,
  upload,
}